export var paramValidatorError = function (type, message) {
    return new Error("Url Mappings Error - [".concat(type, "]: ").concat(message));
};
//# sourceMappingURL=errors.js.map